import React, { useState, useEffect, useRef } from 'react'
import "./../styles/crossword.css";
import "./../styles/crossword2.css";
import { Link } from 'react-router-dom'
import GameNav from '../GameNav';


export default function CrossWordTwo() {

    const [activeQuestion, setActiveQuestion] = useState(1);
    const [activeStreak, setActiveStreak] = useState([]);
    const [inputValues, setInputValues] = useState([]);
    const [checkAnswersClicked, setCheckAnswersClicked] = useState(false);

    const rows = 15;
    const cols = 15;
    const initialPuzzleState = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null));
    const [puzzle, setPuzzle] = useState(initialPuzzleState);
    const [win, setWin] = useState(false);

    const correctAnswers = [
        'S', 'S', 'A', 'A', 'R', 'R', 'N', 'G', 'E', 'R', 'C', 'C', 'O', 'M', 'P', 'A', 'N', 'I', 'S', 'T', 'H', 'A', 'R', 'A',
        'C', 'T', 'E', 'R', 'O', 'P', 'E', 'N', 'E', 'R', 'T', 'H', 'E', 'E', 'B', 'A', 'L', 'L', 'A', 'D', 'D', 'N', 'C', 'E', '-', 'C', 'A', 'P', 'T', 'I', 'O', 'S', 'T', 'U', 'M', 'E', 'W', 'I', 'N', 'G'
    ]







    const resetGame = () => {
        setActiveQuestion(1);
        setPuzzle(initialPuzzleState);
        setInputValues([]);
        setEnteredValues(Array(filledCells.length).fill(null));
        setCheckAnswersClicked(false);
        setWin(false);  // Reset win state
    };


    //cells that have a space signifying that the answer is 2 words
    const spaceCells = [
        [8, 7]
    ]



    const filledCells = [

        [0, 6],
        [1, 6],
        [2, 6],

        [2, 3],
        [2, 4],
        [2, 5],
        [2, 7],
        [2, 8],
        [2, 9],
        [2, 10],



        [3, 3],
        [4, 3],
        [5, 3],
        [6, 3],
        [7, 3],
        [8, 3],
        [9, 3],
        [10, 3],
        [11, 3],
        [12, 3],



        [4, 4],
        [4, 5],
        [4, 6],
        [4, 7],
        [4, 8],
        [4, 9],
        [4, 10],
        [4, 11],



        [5, 14],
        [6, 14],
        [7, 14],
        [8, 14],
        [9, 14],
        [10, 14],


        [6, 0],
        [6, 1],
        [6, 2],
        [6, 4],



        [7, 12],
        [8, 12],
        [9, 12],
        [10, 12],
        [11, 12],
        [12, 12],


        [8, 2],   //this one
        [8, 4],
        [8, 5],
        [8, 6],
        [8, 7],
        [8, 8],
        [8, 9],
        [8, 10],
        [8, 11],
        [8, 13],


        [9, 5],
        [10, 5],
        [11, 5],
        [12, 5],
        [13, 5],
        [14, 5],



        [10, 6],
        [10, 7],
        [10, 8],
        [10, 9]


    ];




    const [enteredValues, setEnteredValues] = useState(Array(filledCells.length).fill(null));

    useEffect(() => {
        if (activeQuestion === 1) {
            setActiveStreak([
                [0, 6],
                [1, 6],
                [2, 6],
            ]);

            setInputValues([
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 2) {
            setActiveStreak([
                //2 across
                [2, 3],
                [2, 4],
                [2, 5],
                [2, 6],
                [2, 7],
                [2, 8],
                [2, 9],
                [2, 10],

            ]);

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],

            ])

        } else if (activeQuestion === 3) {
            //2 down
            setActiveStreak([
                [2, 3],
                [3, 3],
                [4, 3],
                [5, 3],
                [6, 3],
                [7, 3],
                [8, 3],
                [9, 3],
                [10, 3],
                [11, 3],
                [12, 3]


            ]);

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 4) {
            setActiveStreak([
                [4, 3],
                [4, 4],
                [4, 5],
                [4, 6],
                [4, 7],
                [4, 8],
                [4, 9],
                [4, 10],
                [4, 11],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']


            ])

        } else if (activeQuestion === 5) {
            setActiveStreak([

                [5, 14],
                [6, 14],
                [7, 14],
                [8, 14],
                [9, 14],
                [10, 14]


            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 6) {
            setActiveStreak([
                [6, 0],
                [6, 1],
                [6, 2],
                [6, 3],
                [6, 4]
            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                ['']



            ])
        } else if (activeQuestion === 7) {
            setActiveStreak([

                [7, 12],
                [8, 12],
                [9, 12],
                [10, 12],
                [11, 12],
                [12, 12],


            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']


            ])
        } else if (activeQuestion === 8) {
            setActiveStreak([

                [8, 2],
                [8, 3],
                [8, 4],
                [8, 5],
                [8, 6],
                [8, 7],
                [8, 8],
                [8, 9],
                [8, 10],
                [8, 11],
                [8, 12],
                [8, 13],
                [8, 14],
            ])

            setInputValues([

                [''],
                [''],
                [''],
                [''],
                [''],
                [''], //this is the input with a space
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],

            ])
        } else if (activeQuestion === 9) {
            setActiveStreak([

                [8, 5],
                [9, 5],
                [10, 5],
                [11, 5],
                [12, 5],
                [13, 5],
                [14, 5],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 10) {
            setActiveStreak([

                [10, 5],
                [10, 6],
                [10, 7],
                [10, 8],
                [10, 9],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        }



    }, [activeQuestion]);

    const totalQuestions = 10;




    const handleChange = (index, e) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = e.target.value.toUpperCase();
        setInputValues(newInputValues);
    };


    const handleKeyDown = (index, e) => {
        if (/^[a-zA-Z-]$/.test(e.key)) {
            e.preventDefault();
            const newInputValues = [...inputValues];
            newInputValues[index] = e.key.toUpperCase();
            setInputValues(newInputValues);

            if (index < activeStreak.length - 1) {
                const nextIndex = index + 1;
                document.getElementById(`input-${nextIndex}`).focus();
            }
        } else if (e.key === 'Backspace') {
            e.preventDefault();
            const currentInput = inputValues[index];

            if (currentInput === '') {
                if (index > 0) {
                    const prevIndex = index - 1;
                    document.getElementById(`input-${prevIndex}`).focus();
                }
            } else {
                const newInputValues = [...inputValues];
                newInputValues[index] = '';
                setInputValues(newInputValues);
            }
        }
    };

    const resetInputValues = () => {
        setInputValues(Array(activeStreak.length).fill(''));
    };

    const answerSubmit = () => {
        if (inputValues.every(value => typeof value === 'string' && value.trim() !== '' && value !== null)) {
            const newEnteredValues = [...enteredValues];
            const newPuzzle = puzzle.map(row => [...row]);
            activeStreak.forEach(([row, col], index) => {
                const cellIndex = filledCells.findIndex(([r, c]) => r === row && c === col);
                if (cellIndex !== -1) {
                    newEnteredValues[cellIndex] = inputValues[index];
                    newPuzzle[row] = [...newPuzzle[row]];
                    newPuzzle[row][col] = inputValues[index];
                }
            });
            setEnteredValues(newEnteredValues);
            setPuzzle(newPuzzle);
            nextQuestion();
        } else {
            alert('Please fill in the entire answer before submitting');
        }
    };


    const checkAnswers = (e) => {
        e.preventDefault();
        const isCorrect = enteredValues.every((value, index) => value.toUpperCase() === correctAnswers[index]);
        setCheckAnswersClicked(true);
        if (isCorrect) {
            setWin(true);
        }
    };




    const nextQuestion = () => {
        const newQuestion = (activeQuestion % totalQuestions) + 1;
        setActiveQuestion(newQuestion);
        resetInputValues();
    };

    const prevQuestion = () => {
        const newQuestion = (activeQuestion - 2 + totalQuestions) % totalQuestions + 1;
        setActiveQuestion(newQuestion);
    };



    const grid = Array.from({ length: rows }, () => Array.from({ length: cols }).fill(0));

    filledCells.forEach(([row, col]) => {
        if (row < rows && col < cols) {
            grid[row][col] = 1;
        }
    });


    const gridItems = [];

    const clues = [
        { number: 1, label: 1, start: [0, 6] },
        { number: 2, label: 2, start: [2, 3] },
        { number: 3, label: 2, start: [2, 3] },
        { number: 4, label: 3, start: [4, 3] },
        { number: 5, label: 4, start: [5, 14] },
        { number: 6, label: 5, start: [6, 0] },
        { number: 7, label: 6, start: [7, 12] },
        { number: 8, label: 7, start: [8, 2] },
        { number: 9, label: 8, start: [8, 5] },
        { number: 10, label: 9, start: [10, 5] }
    ];


    const streakClick = (row, col) => {
        const matchingClues = clues.filter(
            clue => clue.start[0] === row && clue.start[1] === col
        );

        if (matchingClues.length > 0) {
            const currentClue = matchingClues.find(
                clue => clue.number === activeQuestion
            );

            const nextClue = currentClue
                ? matchingClues[(matchingClues.indexOf(currentClue) + 1) % matchingClues.length]
                : matchingClues[0];

            setActiveQuestion(nextClue.number);

        }
    };


    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            // const [row, col] = filledCells[index];
            const isFilled = grid[row] && grid[row][col] === 1;



            const isStartOfClue = clues && activeStreak && clues.some(
                (clue) => clue && clue.start && Array.isArray(clue.start) && clue.start[0] === row && clue.start[1] === col
            );


            const isSpaceCell = spaceCells.some(([spaceRow, spaceCol]) => spaceRow === row && spaceCol === col);

            const cellStyle = {
                border: isFilled ? '1px solid #826A8C' : 'none',
                backgroundColor: isSpaceCell ? '#826A8C' : isFilled ? '#fff' : 'transparent',
                boxSizing: 'border-box',
                position: 'relative'

            };

            const cellContent = (
                <div

                >


                    <span
                        className={`entered-letter ${checkAnswersClicked &&
                            enteredValues.find(
                                (value, index) =>
                                    filledCells[index][0] === row && filledCells[index][1] === col
                            ) === correctAnswers[
                            filledCells.findIndex(
                                (cell) => cell[0] === row && cell[1] === col
                            )
                            ]
                            ? 'correct'
                            : checkAnswersClicked &&
                                enteredValues.find(
                                    (value, index) =>
                                        filledCells[index][0] === row && filledCells[index][1] === col
                                ) !== correctAnswers[
                                filledCells.findIndex(
                                    (cell) => cell[0] === row && cell[1] === col
                                )
                                ]
                                ? 'incorrect'
                                : 'mid-game-letter'

                            }`}
                    >
                        {enteredValues.find((value, index) => filledCells[index][0] === row && filledCells[index][1] === col) || ''}
                    </span>


                    {isStartOfClue && (
                        <div className='clue'>
                            {clues.find(clue => clue && clue.start && clue.start[0] === row && clue.start[1] === col)?.label}
                        </div>
                    )}
                </div>
            );
            // win !== true &&
            gridItems.push(
                <div className={`cell ${activeStreak.length > 0 && activeStreak.some(([r, c]) => r === row && c === col) ? 'active-streak-cell' : ''}`} key={`${row}-${col}`} style={cellStyle}
                    onClick={() => streakClick(row, col)}
                >
                    {cellContent}
                </div>
            );
        }
    }


    return (
        <div className='crossword-main'>
            <GameNav />
            <div className='crossword-container'>
                <div className='crossword-bg'>

                    <img className='cw2img1' src='images/crossword/1-min.png' />

                    <img className='cw2img2' src='images/crossword/6.png' />

                    <img className='cw2img3' src='images/crossword/5.png' />
                    <div id='crossword-grid-2'>
                        {gridItems}
                    </div>

                </div>

            </div>


            {win ? (
                <div className='crossword-win-screen'>


                    <h2>You Win!</h2>

                    <Link to='/crossword3'>
                        <button className='nextLevelCWbtn'>Next Level</button>
                    </Link>


                </div>
            ) : (
                <></>
            )}


            <div className='crossword-control-main' style={{ position: 'relative' }}>

                <div className={`cw-outer ${win ? 'win-blur' : ''}`}>
                    <div className='crossword-control'>

                        <div onClick={prevQuestion} className=' prev-btn questions-btn btn-background-circle-q'>
                            <svg className='arrow-prev-q arrow-q' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                                <path
                                    className='prev svg-btn-q'
                                    d="M217.4,165.87a7.76,7.76,0,0,0,0,12.12l52,41.61,38.68,30.94a12.87,12.87,0,0,0,20.91-10h0a12.88,12.88,0,0,0-4.83-10.05L310.62,219.6,251,171.93l59.6-47.65,13.57-10.85A12.89,12.89,0,0,0,329,103.38h0a12.87,12.87,0,0,0-20.91-10l-38.68,31Z"
                                    transform="translate(-214.49 -90.49)"
                                />
                            </svg>
                        </div>
                        <div className={`question ${activeQuestion === 1 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 1</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>

                            <p>Three-part ladies number is denoted by this voice-part abbreviation:</p>
                        </div>
                        <div className={`question ${activeQuestion === 2 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 2</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Name of for the composer who takes a pop song and turns it into a show choir number:</p>
                        </div>
                        <div className={`question ${activeQuestion === 3 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 2</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>The general term for the rehearsal pianist:</p>
                        </div>
                        <div className={`question ${activeQuestion === 4 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 3</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Show choir girls wear what kind of shoes?</p>
                        </div>
                        <div className={`question ${activeQuestion === 5 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 4</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>Name of the first song in a show choir show?</p>
                        </div>
                        <div className={`question ${activeQuestion === 6 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 5</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>When all the show choirs songs are about “love” then the show has an overarching ______</p>
                        </div>
                        <div className={`question ${activeQuestion === 7 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 6</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>Musical term for the slow expressive musical composition?</p>
                        </div>
                        <div className={`question ${activeQuestion === 8 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 7</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Student leader in charge of a section’s choreography? 2 words, enter a dash - where the space is</p>
                        </div>
                        <div className={`question ${activeQuestion === 9 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 8</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>What show choir members wear</p>
                        </div>
                        <div className={`question ${activeQuestion === 10 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 9</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>The term for the dance and big band style of the 1940’s</p>
                        </div>

                        <div onClick={nextQuestion} className=' next-btn questions-btn btn-background-circle-q'>
                            <svg className='arrow-next-q arrow-q' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                                <path
                                    className='next svg-btn-q'
                                    d="M326.1,165.87a7.75,7.75,0,0,1,0,12.12l-52,41.61-38.69,30.94a12.86,12.86,0,0,1-20.9-10h0a12.88,12.88,0,0,1,4.83-10.05l13.57-10.85,59.6-47.67-59.6-47.65-13.57-10.85a12.89,12.89,0,0,1-4.83-10.05h0a12.86,12.86,0,0,1,20.9-10l38.69,31Z"
                                    transform="translate(-214.49 -90.49)"
                                />
                            </svg>
                        </div>
                    </div>
                    <form className='question-input'>
                        <div className='input-cells'>
                            {activeStreak.map((cell, index) => {
                                const [row, col] = cell;

                                // Check if this cell is a space cell
                                const isSpaceCell = spaceCells.some(([spaceRow, spaceCol]) => spaceRow === row && spaceCol === col);

                                return (
                                    <input
                                        key={index}
                                        id={`input-${index}`}
                                        className={`question-input-cell ${isSpaceCell ? 'space-input' : ''} ${activeQuestion === 8 ? 'long-question' : ''}`}
                                        value={inputValues[index]}
                                        onChange={(e) => handleChange(index, e)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                        maxLength={1}
                                    />
                                );
                            })}
                        </div>


                        <div className='input-btns'>
                            {inputValues.every(value => typeof value === 'string' && value.trim() !== '' && value !== null) ? (
                                <div className='submit-btn' onClick={answerSubmit}>
                                    Submit
                                </div>
                            ) : (
                                <div className='submit-btn-disabled' onClick={answerSubmit}>
                                    Submit
                                </div>
                            )}





                            <div>
                                {enteredValues.every(value => value !== null || '') ? (
                                    <button className='check-btn' onClick={checkAnswers}>Check</button>
                                ) : (
                                    <button type="button" className='disabled-check-btn'>Check</button>
                                )
                                }

                            </div>
                        </div>
                    </form>


                </div>

            </div>
            {/* square 7 */}
        </div>
    )
}


